// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"30":"clients","47":"client","177":"home","348":"base","486":"orders","511":"cart","740":"print"}[chunkId] + ".css";
};